"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepTwoOfflineFirstAppointment = void 0;
const react_1 = __importStar(require("react"));
const hooks_1 = require("../../../../../store/hooks");
const reducers_1 = require("../../../../../store/reducers");
const react_native_1 = require("react-native");
const organisms_1 = require("../../../../organisms");
const atome_1 = require("../../../../atome");
const organisms_2 = require("../../../../organisms");
const User_service_1 = __importDefault(require("../../../../../services/User.service"));
const doctorslot_enum_1 = require("../../../../../enums/doctorslot.enum");
const OfflineFirstAppointment_style_1 = require("../OfflineFirstAppointment.style");
const GlobalStyles_1 = require("../../../../../helper/GlobalStyles");
const Breakpoints_1 = require("../../../../../helper/Breakpoints");
// @ts-ignore
function StepTwoOfflineFirstAppointment({ navigation, setCurrentPage, firstAppointmentInfo, setFirstAppointmentInfo, }) {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const [doctorSlots, setDoctorSlots] = (0, react_1.useState)([]);
    const [allDoctorSlots, setAllDoctorSlots] = (0, react_1.useState)([]);
    const [selectedSlot, setSelectedSlot] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [selectedDate, setSelectedDate] = (0, react_1.useState)(new Date(new Date().setHours(0, 0, 0, 0)));
    const getDoctorSlots = (doctorIds) => {
        setLoading(true);
        User_service_1.default.getMultipleDoctorSlotsBySlotType(doctorIds, doctorslot_enum_1.DOCTOR_SLOT.FIRST_APPOINTMENT).then(res => {
            if (res.error) {
                if (res.message.response.status === 401) {
                    dispatch((0, reducers_1.setAuth)({ isAuthenticated: false }));
                    setLoading(false);
                    navigation.navigate('Login');
                }
                console.log(res.message);
            }
            if (!res.data.length) {
                setLoading(false);
                return;
            }
            setAllDoctorSlots(res.data);
            setLoading(false);
        });
    };
    const doctorSlotsFilter = () => {
        const slotsForOfflineFirstAppointment = allDoctorSlots.filter((slot) => slot.type === 0 &&
            slot.subtype === 0 &&
            slot.practiceId === firstAppointmentInfo.location.id);
        setDoctorSlots(slotsForOfflineFirstAppointment);
    };
    (0, react_1.useEffect)(() => {
        if (firstAppointmentInfo.selectedDate !== undefined) {
            setSelectedDate(firstAppointmentInfo.selectedDate);
        }
        getDoctorSlots(firstAppointmentInfo.location.doctorsIds);
    }, []);
    (0, react_1.useEffect)(() => {
        const slots = doctorSlots.filter((slot) => new Date(new Date(slot.start).setHours(0, 0, 0, 0)).getTime() ===
            new Date(selectedDate).getTime());
        setSelectedSlot(slots[0]);
    }, [selectedDate, doctorSlots]);
    const next = () => {
        if (selectedSlot) {
            setFirstAppointmentInfo({
                ...firstAppointmentInfo,
                selectedDate: selectedDate,
                doctorSlots: doctorSlots.filter((slot) => new Date(new Date(slot.start).setHours(0, 0, 0, 0)).getTime() -
                    selectedDate.getTime() ===
                    0),
            });
        }
        let reducerType = {
            type: '[UPDATE]',
            payload: {
                offlineFirstAppointmentIndex: 3,
            },
        };
        setCurrentPage(reducerType);
    };
    (0, react_1.useEffect)(() => {
        doctorSlotsFilter();
    }, [allDoctorSlots]);
    if (loading) {
        return react_1.default.createElement(atome_1.Loading, null);
    }
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(react_native_1.ScrollView, { style: [OfflineFirstAppointment_style_1.styles.scrollview] },
            Breakpoints_1.isDesktop && react_1.default.createElement(organisms_2.UserHeader, { navigation: navigation }),
            react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.container },
                react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.marginTop4px },
                    react_1.default.createElement(atome_1.Icon, { icon: "calendarWithDays", size: 70, color: "#3db384" })),
                react_1.default.createElement(react_native_1.View, { style: OfflineFirstAppointment_style_1.styles.header },
                    react_1.default.createElement(atome_1.Text, { style: [OfflineFirstAppointment_style_1.styles.headerTitle, OfflineFirstAppointment_style_1.styles.greenText] },
                        "Wann soll Ihr Erstgespr\u00E4ch in ",
                        firstAppointmentInfo.location.name,
                        ' ',
                        "stattfinden?")),
                doctorSlots?.length !== 0 ? (react_1.default.createElement(react_native_1.View, { style: [
                        OfflineFirstAppointment_style_1.styles.locationsContainer,
                        OfflineFirstAppointment_style_1.styles.shadowContainer,
                        OfflineFirstAppointment_style_1.styles.calendarContainer,
                    ] },
                    react_1.default.createElement(organisms_1.Calendar, { slots: doctorSlots, onChange: setSelectedDate, selectedDate: selectedDate }))) : (react_1.default.createElement(react_native_1.View, { style: [OfflineFirstAppointment_style_1.styles.locationsContainer] },
                    react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.marginVertical40] },
                        react_1.default.createElement(atome_1.Label, { style: [OfflineFirstAppointment_style_1.styles.textBold, OfflineFirstAppointment_style_1.styles.textNoAppointment] }, "Leider sind derzeit keine Termine verf\u00FCgbar"),
                        react_1.default.createElement(atome_1.Text, { style: [OfflineFirstAppointment_style_1.styles.textNoAppointment] }, "Bitte w\u00E4hlen Sie einen anderen Standort oder setzen Sie sich mit unserem Support in Verbindung."),
                        react_1.default.createElement(react_native_1.Pressable, null,
                            react_1.default.createElement(atome_1.Text, { style: [OfflineFirstAppointment_style_1.styles.greenLinkText, OfflineFirstAppointment_style_1.styles.textNoAppointment], onPress: () => {
                                    let reducerType = {
                                        type: '[UPDATE]',
                                        payload: { offlineFirstAppointmentIndex: 1 },
                                    };
                                    setCurrentPage(reducerType);
                                    return;
                                } }, "Anderen Standort w\u00E4hlen"))),
                    react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.alignCenter, GlobalStyles_1.globalStyles.marginTop40] },
                        react_1.default.createElement(react_native_1.Pressable, { onPress: () => {
                                react_native_1.Linking.openURL('mailto:support@nowomed.de?subject=(Kontaktanfrage App)');
                            } },
                            react_1.default.createElement(atome_1.Text, { style: [OfflineFirstAppointment_style_1.styles.greenLinkText, OfflineFirstAppointment_style_1.styles.textNoAppointment] }, "E-Mail senden"))))),
                doctorSlots?.length !== 0 && (react_1.default.createElement(react_native_1.View, { style: [Breakpoints_1.isDesktop && GlobalStyles_1.globalStyles.row, GlobalStyles_1.globalStyles.marginTop30] },
                    Breakpoints_1.isDesktop && (react_1.default.createElement(react_native_1.View, { style: [OfflineFirstAppointment_style_1.styles.buttonContainer] },
                        react_1.default.createElement(react_native_1.Pressable, { onPress: () => {
                                let reducerType = {
                                    type: '[UPDATE]',
                                    payload: {
                                        offlineFirstAppointmentIndex: 1,
                                    },
                                };
                                setCurrentPage(reducerType);
                            } },
                            react_1.default.createElement(atome_1.Text, { style: [OfflineFirstAppointment_style_1.styles.backButtonText] }, "\u2190 Zur\u00FCck")))),
                    react_1.default.createElement(react_native_1.View, { style: [
                            OfflineFirstAppointment_style_1.styles.buttonContainer,
                            Breakpoints_1.isDesktop && { marginLeft: 370 },
                        ] },
                        react_1.default.createElement(react_native_1.Pressable, { style: [
                                OfflineFirstAppointment_style_1.styles.buttonWeiter,
                                !selectedDate && OfflineFirstAppointment_style_1.styles.disabledButton,
                            ], disabled: (!selectedDate && !selectedSlot) || doctorSlots.length === 0, onPress: next },
                            react_1.default.createElement(atome_1.Text, { style: [OfflineFirstAppointment_style_1.styles.buttonTextWeiter] }, "Weiter")))))))));
}
exports.StepTwoOfflineFirstAppointment = StepTwoOfflineFirstAppointment;
